import { ActivityEntityName } from '@jms/model';

/** The board pill every financial document uses for its live list. */
const ALL_SEGMENT_ID = 'all';

/** Boards whose new save should land on All. A status change never comes through here. */
const FINANCIAL_DOCUMENT_ENTITIES = new Set<ActivityEntityName>([
  ActivityEntityName.Invoice,
  ActivityEntityName.Bill,
  ActivityEntityName.QuotePro,
  ActivityEntityName.PurchaseOrder,
  ActivityEntityName.SaleOrder,
]);

interface CreatedRecordBoard {
  $segmentFilters: () => readonly { _id: string }[];
  selectSegment: (id: string) => void;
  $search?: () => string | null;
  updateHeader?: (data: { search: string | null; page: number }) => void;
  /** Prefer revealFocusedItemId — holds the id until the created row lands in `$items`. */
  revealFocusedItemId?: (id: string) => void;
  setFocusedItemId: (id: string) => void;
}

/**
 * A new record is not on the page the user was browsing. All's first page is where a newest-first
 * list puts it, and revealing that id highlights the card once the page loads — even when the first
 * items emission does not include it yet.
 *
 * A search is cleared too: a new record rarely matches the text the user was filtering by, and a
 * reveal the list cannot show is dropped (the create toast still opens it).
 *
 * Status changes do not come through here. They keep the current pill and page; a record the step
 * moves off that list hands focus to the list's first remaining row.
 */
export function revealCreatedBoardRecord(store: CreatedRecordBoard, entity: ActivityEntityName, result: unknown): void {

  const id = result && typeof result === 'object' ? (result as { _id?: unknown })._id : undefined;
  if (typeof id !== 'string' || id.length === 0) return;

  if (FINANCIAL_DOCUMENT_ENTITIES.has(entity) && store.$segmentFilters().some(segment => segment._id === ALL_SEGMENT_ID)) {
    store.selectSegment(ALL_SEGMENT_ID);
  }
  if (store.$search?.()) store.updateHeader?.({ search: null, page: 0 });
  if (store.revealFocusedItemId) store.revealFocusedItemId(id);
  else store.setFocusedItemId(id);
}
